import { createHttpClient } from "./createHttpClient";
import { videoApiConfig } from "../../utils/authConfig";

export const videoClient = createHttpClient({
  baseURL: videoApiConfig.baseUrl,
});

